export default __webpack_public_path__ + "static/LOGO_THEME_MOBILE-4269fb4c9131868410fede15e094f998.svg";